/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { ChevronIcon, colors, font, spacing } from '@chegg-ui/theme';
import styled, { css } from 'styled-components';
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        lineHeight: theme.font.lineHeight.sm,
        letterSpacing: theme.font.letterSpacing.md,
        lg: {
          fontWeight: theme.font.weight.bold,
          fontSize: theme.font.size.lg,
          iconSize: 'small'
        },
        md: {
          fontWeight: theme.font.weight.medium,
          fontSize: theme.font.size.sm,
          iconSize: 'xsmall'
        },
        sm: {
          fontWeight: theme.font.weight.medium,
          fontSize: theme.font.size.xs,
          iconSize: 'xsmall'
        },
        xs: {
          fontWeight: theme.font.weight.medium,
          fontSize: theme.font.size.xxs,
          iconSize: 'xsmall'
        },
        background: {
          none: {
            defaultColor: colors.violet700,
            hoverColor: colors.violet800,
            inlineDefaultColor: colors.violet700,
            inlineHoverColor: colors.violet800
          },
          dark: {
            defaultColor: colors.white,
            hoverColor: colors.grey200,
            inlineDefaultColor: colors.white,
            inlineHoverColor: colors.grey200
          },
          light: {
            defaultColor: colors.grey700,
            hoverColor: colors.grey900,
            inlineDefaultColor: colors.grey700,
            inlineHoverColor: colors.grey900
          }
        }
      };
    },
    fanta: {
      lineHeight: font.lineHeight.xs,
      letterSpacing: 'normal',
      lg: {
        iconSize: 'xsmall',
        lineHeight: font.lineHeight.sm
      },
      md: {
        fontWeight: font.weight.bold
      },
      background: {
        none: {
          defaultColor: colors.link,
          hoverColor: colors.link,
          inlineDefaultColor: colors.link,
          inlineHoverColor: colors.link
        },
        light: {
          defaultColor: colors.dark,
          hoverColor: colors.dark,
          inlineDefaultColor: colors.dark,
          inlineHoverColor: colors.dark
        }
      }
    },
    prop: themeProp
  };
};
var underlineStyling = css(["&:link,&:visited{text-decoration:none;}&:focus,&:hover,&:active{text-decoration:underline;}"]);
export var PrimaryStyledLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-0"
})(["align-items:center;display:inline-flex;", " ", " font-family:", ";font-size:", ";font-weight:", ";line-height:", ";letter-spacing:", ";", ""], underlineStyling, function (_ref) {
  var isInline = _ref.isInline;
  return isInline ? "\n    text-decoration: underline;\n    &:link,\n    &:visited {\n      text-decoration: underline;\n    }\n  " : "text-decoration: none;";
}, font.family["default"], function (_ref2) {
  var customTheme = _ref2.customTheme,
      size = _ref2.size;
  return customTheme[size].fontSize;
}, function (_ref3) {
  var customTheme = _ref3.customTheme,
      size = _ref3.size;
  return customTheme[size].fontWeight;
}, function (_ref4) {
  var customTheme = _ref4.customTheme,
      size = _ref4.size;
  return customTheme[size].lineHeight || customTheme.lineHeight;
}, function (_ref5) {
  var customTheme = _ref5.customTheme;
  return customTheme.letterSpacing;
}, function (_ref6) {
  var customTheme = _ref6.customTheme,
      adjustToBackgroundColor = _ref6.adjustToBackgroundColor;
  return css(["color:", ";&:visited{color:", ";}&:hover{color:", ";}"], customTheme.background[adjustToBackgroundColor || 'none'].defaultColor, customTheme.background[adjustToBackgroundColor || 'none'].defaultColor, customTheme.background[adjustToBackgroundColor || 'none'].hoverColor);
});
export var SecondaryStyledLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-1"
})(["&:link,&:visited,&:focus,&:hover,&:active{color:", ";}", " align-items:center;display:inline-flex;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";"], colors.dark, underlineStyling, font.family["default"], font.size.px14, font.weight.medium, font.lineHeight.xs);
export var RepositionedChevron = styled(ChevronIcon).withConfig({
  componentId: "sc-1ecizwc-2"
})(["", "}", "}position:relative;"], function (_ref7) {
  var pointing = _ref7.pointing;

  switch (pointing) {
    case 'up':
      return "top: -0.125rem;";

    case 'left':
      return "top: -0.075rem;";

    case 'down':
      return "top: 0;";

    case 'right':
    default:
      return "top: -0.075rem;";
  }
}, function (_ref8) {
  var position = _ref8.position;
  return position === 'left' ? "margin-right: ".concat(spacing.px4, ";") : "margin-left: ".concat(spacing.px4, ";");
});
export var ChevronStyledLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-3"
})([""]);
var seoLinkStyles = css(["font-family:", ";color:", ";&:hover,&:visited{color:", ";}"], font.family["default"], function (_ref9) {
  var customTheme = _ref9.customTheme;
  return customTheme.background['light'].defaultColor;
}, function (_ref10) {
  var customTheme = _ref10.customTheme;
  return customTheme.background['light'].hoverColor;
}); // "SEO" Link definitions follow:

export var SEOEyebrowLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-4"
})(["", " ", " font-size:", ";font-weight:", ";line-height:", ";"], seoLinkStyles, underlineStyling, font.size.px20, font.weight.heavy, font.lineHeight.xs);
export var SEOSubjectLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-5"
})(["", " ", " font-size:", ";font-weight:", ";line-height:", ";"], seoLinkStyles, underlineStyling, font.size.px16, font.weight.bold, font.lineHeight.sm);
export var SEOSubSubjectLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-6"
})(["", " ", " font-size:", ";font-weight:", ";line-height:", ";"], seoLinkStyles, underlineStyling, font.size.px16, font.weight.normal, font.lineHeight.sm);